import { tableHelper } from "@/helpers/table.helper";
import { getBlankCriteria, getBlankRecord, getBlankResendDetails } from "./helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      criteria: getBlankCriteria(),
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      data: [],
      paging: tableHelper.getDefaultPaging("Date", true),
      levyCollectionId: null,
      providerId: null,
      empty: false,
      loading: false,
      loaded: false
    },
    view: {
      data: getBlankRecord(),
      loading: false
    },
    previewSend: {
      data: null,
      loading: false
    },
    previewResend: {
      data: null,
      loading: false
    },
    send: {
      loading: false
    },
    resend: {
      data: getBlankResendDetails(),
      loading: false
    },
    timeline: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      providerId: null,
      data: []
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      empty: false,
      loaded: false
    },
    timeline: {
      loaded: false
    }
  };
}
